import {
  IconButton as ChakraIconButton,
  IconButtonProps as CharkaIconButtonProps,
} from '@chakra-ui/react';

// @doc https://chakra-ui.com/docs/form/icon-button
export type IconButtonProps = CharkaIconButtonProps;
export const IconButton = ChakraIconButton;
